import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-userprofile-form',
  templateUrl: './userprofile-form.component.html',
  styleUrls: ['./userprofile-form.component.css']
})
export class UserprofileFormComponent implements OnInit {

  title="Add User Profile";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/master/userprofile/userprofile-form/userprofile-form.component.ts